import { useState } from "react";
import "./Contact.css";

export default function Contact() {

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [purity, setPurity] = useState("");
  const [gram, setGram] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !phone) {
      alert("Please fill required fields");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("phone", phone);
    formData.append("purity", purity);
    formData.append("gram", gram);

    try {
      const res = await fetch("https://sellgoldcompany.in/send.php", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.status === "success") {
        alert("Message sent ✅");

        setName("");
        setPhone("");
        setCity("");
        setPurity("");
        setGram("");
      } else {
        alert("Error ❌");
      }

    } catch {
      alert("Server error ❌");
    }
  };

  return (
    <section className="contact-section" id="contact">

      <div className="contact-header">
        <span>CONTACT US</span>
        <h2>Sell Your Gold Easily</h2>
      </div>

      <div className="contact-container">

        <div className="contact-info">
          <h3>Why Choose Us?</h3>
          <ul>
            <li>✔ Instant Payment</li>
            <li>✔ Best Market Price</li>
            <li>✔ No Hidden Charges</li>
            <li>✔ 100% Safe & Secure</li>
          </ul>
          <p>Get best value with full transparency.</p>
        </div>

        <div className="contact-form">
          <h3>Get Instant Quote</h3>

          <form onSubmit={handleSubmit}>

            <div className="input-group">
              <input
                type="text"
                placeholder="Your Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <input
                type="text"
                placeholder="Mobile Number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <input
                type="text"
                placeholder="City"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </div>

            <div className="input-group">
              <select
                value={purity}
                onChange={(e) => setPurity(e.target.value)}
              >
                <option value="">Gold Purity</option>
                <option>18K</option>
                <option>20K</option>
                <option>22K</option>
                <option>24K</option>
              </select>
            </div>

            <div className="input-group">
              <input
                type="text"
                placeholder="Gold Weight (grams)"
                value={gram}
                onChange={(e) => setGram(e.target.value)}
              />
            </div>

            <button type="submit">Get Price</button>

          </form>
        </div>

      </div>

    </section>
  );
}